export const MEDIA_BREAKPOINTS = [500, 768, 1280, 1920];

export const mediaQueries = MEDIA_BREAKPOINTS.map(
  (bp) => `@media (min-width: ${bp}px)`
);
